// extracted by mini-css-extract-plugin
export default {"container":"Search_container__gldYc","barANDdropdown":"Search_barANDdropdown__keIYj","results":"Search_results__6+qmE"};